import React from 'react';
import CloseWindowButton from '../../../../../../atomic/buttons/closeWindow/CloseWindowButton';
import LossLimitModule from '../modules/LossLimitModule';
import style from './ModuleWrapper.module.css';
import PropTypes from 'prop-types';
import PreserveProfitModule from '../modules/PreserveProfitModule';
import UnderlyingPriceModule from '../modules/UnderlyingPriceModule';
import PositionPriceTrailModule from '../modules/PositionPriceTrailModule';
import CandleTrailModule from '../modules/CandleTrailModule';
import GrabCentsModule from '../modules/GrabCentsModule';
import GreenToRedCandlesModule from '../modules/GreenToRedCandlesModule';
import GreenToRedPositionsModule from '../modules/GreenToRedPositionsModule';
import RatchetBracketModule from '../modules/RatchetBracketModule';
import BreakPriceModule from '../modules/BreakPriceModule';
import CandleMagnitudeModule from '../modules/CandleMagnitudeModule';
import { AtrTrailModule } from '../modules/AtrTrailModule';
import { MfeRetracementModule } from '../modules/MfeRetracementModule';
import { UnderlyingPriceExitModule } from '../modules/UnderlyingPriceExitModule';
import { PositionBreakPriceModule } from '../modules/PositionBreakPriceModule';

function ModuleWrapper({ type, index, removeTactic, stateProps }) {
  let component;
  let setter;
  switch (type) {
    case 'Loss Limit':
      component = <LossLimitModule state={stateProps.lossLimit} />;
      setter = stateProps.lossLimit[3];
      break;
    case 'Preserve Profit':
      component = <PreserveProfitModule state={stateProps.preserveProfit} />;
      setter = stateProps.preserveProfit[3];
      break;
    case 'Underlying Price Trail': // do not show if stock is selected
      component = (
        <UnderlyingPriceModule state={stateProps.underlyingPriceTrail} />
      );
      setter = stateProps.underlyingPriceTrail[3];
      break;
    case 'Position Price Trail':
      component = (
        <PositionPriceTrailModule state={stateProps.positionPriceTrail} />
      );
      setter = stateProps.positionPriceTrail[3];
      break;
    case 'Candle Trail':
      component = <CandleTrailModule state={stateProps.candleTrail} />;
      setter = stateProps.candleTrail[3];
      break;
    case 'Grab Cents':
      component = <GrabCentsModule state={stateProps.grabCents} />;
      setter = stateProps.grabCents[3];
      break;
    case 'Ratchet Bracket':
      component = <RatchetBracketModule state={stateProps.ratchetBracket} />;
      setter = stateProps.ratchetBracket[3];
      break;
    case 'Green To Red Candles':
      component = (
        <GreenToRedCandlesModule state={stateProps.greenToRedCandles} />
      );
      setter = stateProps.greenToRedCandles[3];
      break;
    case 'Green To Red Positions':
      component = (
        <GreenToRedPositionsModule state={stateProps.greenToRedPositions} />
      );
      setter = stateProps.greenToRedPositions[3];
      break;
    case 'Underlying Break Price':
      component = <BreakPriceModule state={stateProps.breakPrice} />;
      setter = stateProps.breakPrice[3];
      break;
    case 'Candle Magnitude':
      component = <CandleMagnitudeModule state={stateProps.candleMagnitude} />;
      setter = stateProps.candleMagnitude[3];
      break;
    case 'Atr Trail':
      component = <AtrTrailModule state={stateProps.atrTrail} />;
      setter = stateProps.atrTrail[3];
      break;
    case 'Mfe Retracement':
      component = <MfeRetracementModule state={stateProps.mfeRetracement} />;
      setter = stateProps.mfeRetracement[3];
      break;
    case 'Underlying Price Exit':
      component = (
        <UnderlyingPriceExitModule state={stateProps.underlyingPriceExit} />
      );
      setter = stateProps.underlyingPriceExit[3];
      break;
    case 'Position Break Price':
      component = (
        <PositionBreakPriceModule state={stateProps.positionBreakPrice} />
      );
      setter = stateProps.positionBreakPrice[3];
      break;
    default:
      break;
  }
  return (
    <div className={style.wrapper}>
      {component}
      <CloseWindowButton
        width={10}
        color="red"
        stroke={3}
        display="block"
        handleClick={() => {
          removeTactic(index);
          setter(false);
        }}
      />
    </div>
  );
}
ModuleWrapper.propTypes = {
  type: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  removeTactic: PropTypes.func.isRequired,
  stateProps: PropTypes.object.isRequired,
};
export default ModuleWrapper;
